import { render } from "./SupplierTableItem.vue?vue&type=template&id=0d6c96d2&scoped=true&ts=true&lang=pug"
import script from "./SupplierTableItem.vue?vue&type=script&lang=ts"
export * from "./SupplierTableItem.vue?vue&type=script&lang=ts"

import "./SupplierTableItem.vue?vue&type=style&index=0&id=0d6c96d2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6c96d2"]])

export default __exports__